import React, { useState } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { AppBar, IconButton, Menu, MenuItem, Toolbar } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import MenuIcon from '@material-ui/icons/Menu';

import './index.scss';
import InstorexLogo from '../../assets/images/InstoreX3-02.png';
import { ROUTES } from '../../constants';
import { userActions } from '../../redux/actions';


const useStyles = makeStyles((theme) =>
  createStyles({
    logo: {
      marginLeft: 24,
      maxWidth: 200,
      maxHeight: 80,
      flexGrow: 11,
    },
    logoMobileSmall: {
      maxWidth: 100,
      maxHeight: 150,
    },
  }),
);

export default function Navbar() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const [personMenu, setPersonMenu] = useState(null);
  const isMenuOpen = Boolean(personMenu);

  const { user } = useSelector(state => state.userAuthentication);

  const isMobileSmall = useMediaQuery(theme.breakpoints.up('sm'));

  const handleProfileMenuOpen = (event) => {
    setPersonMenu(event.currentTarget);
  }

  const handleMenuClose = () => {
    setPersonMenu(null);
    // handleMobileMenuClose();
  };

  const handleUserLogout = (event) => {
    event.preventDefault();

    if (user) {
      dispatch(userActions.logout(user.refresh));
      setPersonMenu(null);
    }
  }

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={personMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>User Info</MenuItem>
      <MenuItem onClick={handleUserLogout}>Logout</MenuItem>
    </Menu>
  );

  return (
    <>
      <AppBar className="appbar-header" position="static">
        <a href={ROUTES.DASHBOARD}>
          <img className={isMobileSmall ? classes.logo : classes.logoMobileSmall} src={InstorexLogo} alt="Auditive Logo" />
        </a>
        <Toolbar className="app-toolbar">
          <div>
            <IconButton
              edge="end"
              aria-label="account of current user"
              // aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <PersonIcon />
            </IconButton>
            <IconButton edge="start" className="appbar-menu" color="inherit" aria-label="menu">
              <MenuIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMenu}
    </>
  )
}